import { useState } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useUpdateAgentEmail = () => {
	const [loading, setLoading] = useState(false);

	const updateAgentEmail = async (email) => {
		setLoading(true);

		try {
			const result = await AgentsAPI.updateAgentEmail(email);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update agent email:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateAgentEmail,
		loading,
	};
};

export default useUpdateAgentEmail;
